import { Chip } from '@mui/material'
import { Group } from 'features/groups'
import GroupAvatar from 'features/account/ui/AccountGroups/AccountGroupsTable/GroupAvatar'

function GroupChip({
  group,
  disabled,
  onDelete
}: {
  group: Group
  disabled?: boolean
  onDelete: (group: Group) => void
}) {
  return (
    <Chip
      key={group.id}
      disabled={disabled}
      label={group.customName}
      size="small"
      variant="outlined"
      color="default"
      avatar={<GroupAvatar group={group} size="xsmall" />}
      onDelete={!disabled ? () => onDelete(group) : undefined}
    />
  )
}

export default GroupChip
